import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";
//import { get } from 'lodash';
import InputField from "../../../../../Components/Forms/Fields/Input";
//import SelectField from '../../../../../Components/Forms/Fields/Select';
//import Wysiwyg from '../../../../../Components/Forms/Fields/Wysiwyg';
import Validations from "../../../../../Components/Forms/Validations";
import EditForm from "../../../../../Components/Forms/Builder/EditForm";
import { connect } from "react-redux";
import localize from "helpers/localize";

class WorkfeeForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleInputChange: PropTypes.func.isRequired,
    fieldErrors: PropTypes.object,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired
  };

  render() {
    const {
      handleInputChange,
      fieldErrors,
      isViewPage,
      enabledFields
    } = this.props;

    return (
      <EditForm {...this.props}>
        <div className="col-12">
          <Field
            name="name"
            label={localize("workfees", "Megnevezés")}
            fieldError={fieldErrors.name}
            onChange={() => handleInputChange("name")}
            isRequired={true}
            validate={[Validations.required]}
            component={InputField}
            type="text"
            placeholder={localize("workfees", "Megnevezés")}
            isViewPage={isViewPage}
            readOnly={
              enabledFields
                ? enabledFields.indexOf("name") !== -1
                  ? false
                  : true
                : false
            }
          />
        </div>
        <div className="col-12">
          <Field
            name="price"
            label={localize("workfees", "Egységár")}
            fieldError={fieldErrors.price}
            onChange={() => handleInputChange("price")}
            isRequired={true}
            validate={[Validations.required]}
            component={InputField}
            type="text"
            placeholder={localize("workfees", "Egységár")}
            isViewPage={isViewPage}
            readOnly={
              enabledFields
                ? enabledFields.indexOf("price") !== -1
                  ? false
                  : true
                : false
            }
          />
        </div>
      </EditForm>
    );
  }
}

const UsersReduxForm = reduxForm({
  form: "workfees",
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  updateUnregisteredFields: true,
  destroyOnUnmount: false
})(WorkfeeForm);

export default connect(
  state => ({
    initialValues: state.workfees.viewData
  }),
  null
)(UsersReduxForm);



// WEBPACK FOOTER //
// ./src/Containers/Pages/Worksheets/Workfees/views/WorkfeeForm.js